import { execOnLoad } from '@general/helpers';
import './desktop-menu.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initDesktopMenu = (context) => {
  const snippetContainer = context.classList.contains(
    '.desktop-menu__container',
  )
    ? context
    : context.closest('.desktop-menu__container');
  if (!snippetContainer) return;

  const firstLevels = [
    ...snippetContainer.querySelectorAll('.desktop-menu__first-level-link'),
  ];
  firstLevels.forEach((firstLevel) => {
    const wrapper = firstLevel.querySelector(':scope > span, :scope > a');
    const text = firstLevel.querySelector(
      ':scope > a > span, :scope > span > span',
    );
    const dropdown = firstLevel.querySelector('.desktop-menu__dropdown');
    if (!wrapper || !text) return;

    wrapper.addEventListener('mouseenter', () => {
      if (
        firstLevel.classList.contains('open') ||
        firstLevels.some((el) => el.classList.contains('open')) ||
        !dropdown
      )
        return;
      firstLevel.classList.add('open');
    });

    text.addEventListener('mouseenter', () => {
      if (firstLevel.classList.contains('open')) return;
      firstLevels.forEach((el) => el.classList.remove('open'));
      if (!dropdown) return;
      firstLevel.classList.add('open');
    });
  });

  snippetContainer.addEventListener('mouseleave', () => {
    firstLevels.forEach((dropdown) => dropdown.classList.remove('open'));
  });
};

execOnLoad(window.dAgency.initDesktopMenu, '.desktop-menu__container');
